// extracted by mini-css-extract-plugin
export var autoExpand = "_1z-b";
export var container = "_1z-a";
export var containerWidth = "_1z-8";
export var disabled = "_1z-2";
export var error = "_1z-3";
export var fullWidth = "_1z-9";
export var highlightContainer = "_1z-5";
export var inputWrapper = "_1z-0";
export var small = "_1z-1";
export var textarea = "_1z-4";
export var validatedTextarea = "_1z-6";
export var visuallyHidden = "_1z-7";